import { useEffect, useState } from "react";
import { Trash2, ImageOff, Check } from "lucide-react";
import StaffLayout from "@/components/staff/StaffLayout";
import { api, API } from "@/lib/api";
import { toast } from "sonner";

export default function StaffMediaPage() {
  const [files, setFiles] = useState([]);
  const [filter, setFilter] = useState("all");

  function load() {
    api.get("/admin/media").then((r) => setFiles(r.data));
  }
  useEffect(load, []);

  async function del(id) {
    if (!confirm("Delete this image? It will be removed from any room.")) return;
    await api.delete(`/admin/media/${id}`);
    toast.success("Deleted");
    load();
  }

  const visible = filter === "all" ? files :
    filter === "unused" ? files.filter((f) => !f.in_use) :
    files.filter((f) => f.in_use);

  return (
    <StaffLayout>
      <h1 className="font-display text-4xl">Media library</h1>
      <p className="text-sm text-[#71717A] mt-1">All uploaded photos. Delete what you no longer need.</p>

      <div className="mt-6 flex gap-2 text-xs">
        {[["all", "All"], ["in_use", "In use"], ["unused", "Unused"]].map(([k, l]) => (
          <button key={k} data-testid={`media-filter-${k}`} onClick={() => setFilter(k)}
            className={`px-3 py-1.5 rounded-sm uppercase tracking-wider ${filter === k ? "bg-brand-primary text-white" : "bg-white border border-[#E4E4E7]"}`}>{l}</button>
        ))}
        <div className="ml-auto text-[#71717A] text-xs self-center">{visible.length} of {files.length}</div>
      </div>

      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {visible.length === 0 && <div className="col-span-full bg-white border border-[#E4E4E7] rounded-md p-12 text-center text-[#71717A]">No images here.</div>}
        {visible.map((f) => (
          <div key={f.id} data-testid={`media-${f.id}`} className="relative group bg-white border border-[#E4E4E7] rounded-sm overflow-hidden">
            <div className="aspect-square">
              <img src={`${API}${f.url.replace(/^\/api/, "")}`} alt={f.original_filename} className="w-full h-full object-cover" loading="lazy" />
            </div>
            {f.in_use ? (
              <div className="absolute top-2 left-2 bg-emerald-600 text-white text-[10px] uppercase tracking-wider px-2 py-1 rounded-sm flex items-center gap-1"><Check size={11} /> In use</div>
            ) : (
              <div className="absolute top-2 left-2 bg-zinc-700 text-white text-[10px] uppercase tracking-wider px-2 py-1 rounded-sm flex items-center gap-1"><ImageOff size={11} /> Unused</div>
            )}
            <button data-testid={`media-del-${f.id}`} onClick={() => del(f.id)} className="absolute top-2 right-2 bg-rose-600 hover:bg-rose-700 text-white rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition">
              <Trash2 size={13} />
            </button>
            <div className="px-2 py-1.5 text-[10px] text-[#71717A] truncate">{f.original_filename || "—"}</div>
          </div>
        ))}
      </div>
    </StaffLayout>
  );
}
